import React from "react";
import { CustomButton } from "../../../../components/ui/button/CustomButton/CustomButton";

interface RecipeFormActionsProps {
  hasError: boolean;
  errorMessage: string;
  validationErrorExists: boolean;
  onCancel: () => void;
  onSave: () => void;
  isSaveDisabled: boolean;
}

/**
 * Component for recipe form actions and error messages
 * Follows Single Responsibility Principle - handles form actions UI
 */
export const RecipeFormActions: React.FC<RecipeFormActionsProps> = ({
  hasError,
  errorMessage,
  validationErrorExists,
  onCancel,
  onSave,
  isSaveDisabled
}) => {
  return (
    <>
      {/* Error Messages */}
      {hasError && (
        <div className="tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-md tw-p-3.5">
          <p className="tw-text-sm tw-text-red-600">{errorMessage}</p>
        </div>
      )}

      {/* Action Buttons */}
      <div className="tw-flex tw-justify-end tw-pt-2.5">
        <div className="tw-flex tw-gap-2 tw-w-1/2">
          <CustomButton
            onClick={onCancel}
            title="Cancel"
            theme="green"
            buttonOutLine={true}
            disabled={validationErrorExists}
            wrapInColumn={false}
            className="tw-flex-1"
            customButtonStyle="tw-text-sm tw-px-3.5 tw-py-3.5 tw-h-10"
          />
          <CustomButton
            onClick={onSave}
            title="Save"
            theme="green"
            disabled={isSaveDisabled}
            wrapInColumn={false}
            className="tw-flex-1"
            customButtonStyle="tw-text-sm tw-px-3.5 tw-py-3.5 tw-h-10"
          />
        </div>
      </div>
    </>
  );
};
